import api from './api';

const tripService = {
  // Get all trips
  getTrips: async (params = {}) => {
    try {
      const response = await api.get('/voyages', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching trips:', error);
      throw error;
    }
  },

  // Get trip by ID
  getTripById: async (id) => {
    try {
      const response = await api.get(`/voyages/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching trip ${id}:`, error);
      throw error;
    }
  },

  // Create new trip
  createTrip: async (tripData) => {
    try {
      const response = await api.post('/voyages', tripData);
      return response.data;
    } catch (error) {
      console.error('Error creating trip:', error);
      throw error;
    }
  },

  // Update trip
  updateTrip: async (id, tripData) => {
    try {
      const response = await api.put(`/voyages/${id}`, tripData);
      return response.data;
    } catch (error) {
      console.error(`Error updating trip ${id}:`, error);
      throw error;
    }
  },

  // Delete trip
  deleteTrip: async (id) => {
    try {
      const response = await api.delete(`/voyages/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting trip ${id}:`, error);
      throw error;
    }
  },

  // Update trip status
  updateTripStatus: async (id, status) => {
    try {
      const response = await api.patch(`/voyages/${id}/statut`, { status });
      return response.data;
    } catch (error) {
      console.error(`Error updating trip status ${id}:`, error);
      throw error;
    }
  },

  // Cancel trip
  cancelTrip: async (id, reason) => {
    try {
      const response = await api.patch(`/voyages/${id}/annulation`, { reason });
      return response.data;
    } catch (error) {
      console.error(`Error canceling trip ${id}:`, error);
      throw error;
    }
  },

  // Reset non-invoiced trips
  resetNonInvoicedTrips: async () => {
    try {
      const response = await api.post('/voyages/reset-non-invoiced');
      return response.data;
    } catch (error) {
      console.error('Error resetting non-invoiced trips:', error);
      throw error;
    }
  },

  // Get non-invoiced trips by client and month
  getNonInvoicedTrips: async (clientId, month) => {
    try {
      const response = await api.get('/voyages/non-factures', {
        params: { client_id: clientId, month }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching non-invoiced trips:', error);
      throw error;
    }
  }
};

export default tripService;